module.exports = __webpack_public_path__ + "static/img/news_man.62d944e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_man.png
// module id = Q6kv
// module chunks = 0